import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal, Row, Col, Divider } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as ProductoCrud from 'services/producto.service'

import FileFormGroup from './formGroups/file'

const ImportarRegistrosModal = ({ handleClose, show, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)
  const [informe, setInforme] = React.useState(null) // ✅ para almacenar el excel de log cuando hay duplicados

  const formInitialValues = React.useMemo(
    () => ({
      file: ''
    }),
    []
  )

  const submitHandler = data => {
    __zariContext.loader.open('Importando registros')

    const submitData = new FormData()
    submitData.append('file', data.file)

    ProductoCrud.importarExcelProductos(submitData)
      .then(({ data, headers }) => {
        const contentType = headers['content-type']

        if (
          contentType &&
          contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        ) {
          // ✅ caso cuando backend devuelve informe en Excel
          __zariContext.snack('success', `Importación exitosa con observaciones`)
          setInforme({ data, headers })
        } else {
          // ✅ caso normal sin duplicados
          __zariContext.snack('success', `Los datos se han importado correctamente`)
          reloadTable()
          handleClose()
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }

  const clickDescargarPlantilla = React.useCallback(() => {
    ProductoCrud.descargarPlantillaImportarProductos().then(({ data, headers }) => {
      DownloadAxiosFile.downloadAsBlob(data, headers, 'Importar productos.xlsx')
    })
  }, [])

  const clickDescargarInforme = React.useCallback(() => {
    if (informe) {
      DownloadAxiosFile.downloadAsBlob(informe.data, informe.headers, 'resultado_importacion.xlsx')
      setInforme(null)
      reloadTable()
      handleClose()
    }
  }, [informe, reloadTable, handleClose])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>IMPORTAR EXCEL</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <Button outline block onClick={clickDescargarPlantilla}>
                    Descargar plantilla
                  </Button>
                </Col>
              </Row>
              <Divider />
              <FileFormGroup
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iError={errors.file}
                iTouched={touched.file}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              {informe && (
                <Button color='secondary' onClick={clickDescargarInforme}>
                  Descargar informe
                </Button>
              )}
              <Button onClick={handleSubmit}>Importar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ImportarRegistrosModal
